/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {listRenderedWidgets} from '../api'

 export const useQueryListRenderedWidgets = createReactQueryHook('listRenderedWidgets', listRenderedWidgets)
